import ReactPixel from "react-facebook-pixel";
import UserStore from "../../stores/UserStore"
import { toJS } from "mobx";
import { toast } from "react-toastify";

const { makeAutoObservable } = require("mobx");

class QuestionareStore {
  
  QUESTIONS = []

  navigate = null;

  totalScore = 0;
  textInputValues = {};
  ratings = {};
  selectedOptions = {};
  currentStepIndex = 0;
  journey_id = -1

  constructor() {
    makeAutoObservable(this);
  }

  setQuestions(data){
	  this.QUESTIONS = data
  }

  setJourneyId(id){
    this.journey_id = id
  }

  setCurrentStepIndex(idx){
    this.currentStepIndex = idx;
  }

  setTotalScore(curr_score){
    this.totalScore += curr_score
  }

  setTextInputValue(key, value){
	  this.textInputValues[key]= value
  }

  setSelectedOptions(questionKey, selectedIndices){
    this.selectedOptions[questionKey] = selectedIndices;
  }

  setRatingValue(key, value){
    this.ratings[key] = value
  }

  getTotalScore(){
    let scores = 0; 
    this.QUESTIONS.forEach((question, qIdx) => {
        const selected = this.selectedOptions[qIdx] || [];
        selected.forEach(idx => {
            scores += Number(question.options[idx]?.option_score || 0);
        })
    })
    return scores;
  }

  getTextInputValue(key){
    return this.textInputValues[key] || ""
  }

  getCurrentStepIndex(){
    return this.currentStepIndex;
  }

  getRatingValue(key){
    return this.ratings[key] || 3
  }

  selectOption(optionIndex) {
    const questionKey = this.getCurrentStepIndex();
    const isMultiSelectStep =
      this.QUESTIONS[questionKey].select_type === "multi_select";
    let selected = this.selectedOptions[questionKey] || [];
    const optionScore = Number(this.QUESTIONS[questionKey].options[optionIndex].option_score || 0);
    // console.log("score for this option: ", optionScore)

    if (isMultiSelectStep) {
      if (selected.includes(optionIndex)) {
        selected = selected.filter(idx => idx !== optionIndex);
      } else {
        selected = [...selected, optionIndex];
      }
    } else {
      this.clearCurrentSelections();
      selected = [optionIndex];
    }

    this.setSelectedOptions(questionKey, selected);

    // Update isSelected for UI rendering
    this.QUESTIONS[questionKey].options.forEach((option, idx) => {
      option.isSelected = selected.includes(idx);
    });

    this.QUESTIONS[questionKey].isComplete = this.isStepComplete();
  }

  setNavigation(navigate) {
    this.navigate = navigate;
  }

  handleBackPress = () => {
    //if current screen is a score based display screen, go back until some other type of screen is found
    //if previous screen is a score based screen, go back till the correct score screen
    let currIdx = this.getCurrentStepIndex();
    let prev_idx = currIdx - 1;
    // let item = this.QUESTIONS[prev_idx];
    
    while(prev_idx>=0 && 
        (this.QUESTIONS[prev_idx].screen_type === "output" || this.QUESTIONS[prev_idx].screen_type === "display") && 
        this.QUESTIONS[prev_idx].start_value!=="" && Number(this.QUESTIONS[prev_idx].end_value) !== 0
    ){
        const totalScore = this.getTotalScore();
        if(Number(this.QUESTIONS[prev_idx].start_value) <= totalScore && totalScore<=Number(this.QUESTIONS[prev_idx].end_value)){
            break;
        }
        prev_idx -= 1;
    }

    this.setCurrentStepIndex(prev_idx);
  };

  handleNextPress = () => {
    let curr_idx = this.getCurrentStepIndex();
    if (curr_idx >= this.QUESTIONS.length-1) {
      localStorage.setItem(`journey-complete-${this.journey_id}`, 'true');
      toast.success("You have completed this journey! This tab can now be closed.")
      return;
    }

    if(this.QUESTIONS[curr_idx].select_type==="text_textarea"){
      console.log(this.textInputValue);
    }
    
    let selected_option = [] 

    this.QUESTIONS[curr_idx].options.map((item) => {
      if (item.isSelected) {
        selected_option = toJS(item)
      }
    });
    const data = {
      screen_option: selected_option
    }  

    //if next screen is a score based display screen, move forward until the correct screen is found
    //curr_screen is a display screen, move past all other display screens
    let next_idx = curr_idx+1;
    // let item = this.QUESTIONS[next_idx];

    const totalScore = this.getTotalScore();
    
    while(
        next_idx<this.QUESTIONS.length && 
        (this.QUESTIONS[next_idx].screen_type === "output" || this.QUESTIONS[next_idx].screen_type === "display") &&
        this.QUESTIONS[next_idx].start_value!=="" && Number(this.QUESTIONS[next_idx].end_value) !== 0
    ){
        
        // console.log("total score is- ", totalScore)
        if(
            Number(this.QUESTIONS[next_idx].start_value) <= totalScore &&
            totalScore <= Number(this.QUESTIONS[next_idx].end_value)
        ){
            
            break;
        }
        next_idx += 1;
    }

    this.setCurrentStepIndex(next_idx);
  };

  isStepComplete = () => {
    let curr_idx = this.getCurrentStepIndex();
    let isComplete = false;
    if(this.QUESTIONS[curr_idx].screen_type === 'output') return true;
    this.QUESTIONS[curr_idx].options.map((item) => {
      if (item.isSelected) {
        isComplete = true;
      }
    });

    return isComplete;
  };

  isNextButtonDisabled = (isQuestion) => {
    //email input screen
    let curr_idx = this.getCurrentStepIndex();
    if (curr_idx === this.QUESTIONS.length) {
      return !UserStore.email || !UserStore.isEmailValid;
    } 
    else if(this.QUESTIONS[curr_idx].screen_type === "output") {
      return false;
    }
    else if(this.QUESTIONS[curr_idx].screen_type === "display") return false;
    else if(this.QUESTIONS[curr_idx].select_type === "range_select_5" || 
      this.QUESTIONS[curr_idx].select_type === 'range_select_10'
    ){
      return false;
    }
    else if (isQuestion) {
      return !((this.selectedOptions[curr_idx] || []).length > 0);
    }
    //information screens
    else {
      return false;
    }
  };

  clearCurrentSelections = () => {
    let curr_idx = this.getCurrentStepIndex();
    this.QUESTIONS[curr_idx].options.map((item, index) => {
      if(this.QUESTIONS[curr_idx].options[index].isSelected === true){
        // const optionScore = Number(this.QUESTIONS[this.currentStepIndex].options[index].option_score || 0);
        // this.totalScore -= optionScore;
        // this.setTotalScore(-optionScore)
        this.QUESTIONS[curr_idx].options[index].isSelected = false;
      }  
      
    });
  };
}

export default new QuestionareStore();
